import { useEffect, useState } from 'react';
import { getContacts } from 'src/services/client';
import {
  IContact,
  IRoleWrapper,
} from 'src/services/api/ServiceRequestDashboard/apiContracts';

interface UseContactsReturn {
  contacts: IContact[];
  homeOwnersAndOccupantContacts: IContact[];
  propertyDevelopersAndServiceManagerContacts: IContact[];
  isLoading: boolean;
  error: string | null;
  refetchContactsDataList: () => Promise<void>;
}

export const useRetrieveContactsFromAPI = (): UseContactsReturn => {
  const [contacts, setContacts] = useState<IContact[]>([]);
  const [homeOwnersAndOccupants, setHomeOwnersAndOccupants] =
    useState<any>(null);
  const [
    propertyDevelopersAndServiceManagers,
    setPropertyDevelopersAndServiceManagers,
  ] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const filterContactsByRoles = (
    contactData: IContact[],
    roleNames: string[]
  ) => {
    const filteredContacts = contactData.filter((contact: IContact) => {
      return contact.roles.some((role: IRoleWrapper) => {
        return roleNames.includes(role.role.name);
      });
    });

    return filteredContacts;
  };

  const fetchAllContacts = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      const response: any = await getContacts();

      if (response.ok || response.status === 200) {
        const contactData = await response.json();
        const propertyDevsAndServiceManagerContacts = filterContactsByRoles(
          contactData,
          ['Service Manager', 'Property Developer']
        );
        const homeownerOccupantContacts = filterContactsByRoles(contactData, [
          'Home Owner',
          'Occupant',
        ]);
        setContacts(contactData);
        setPropertyDevelopersAndServiceManagers(
          propertyDevsAndServiceManagerContacts
        );
        setHomeOwnersAndOccupants(homeownerOccupantContacts);
      } else {
        setError('Failed to fetch contacts');
      }
    } catch (err) {
      console.error('Error fetching contacts:', err);
      setError('An error occurred while fetching contacts');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllContacts();
  }, []);

  return {
    contacts,
    homeOwnersAndOccupantContacts: homeOwnersAndOccupants,
    propertyDevelopersAndServiceManagerContacts:
      propertyDevelopersAndServiceManagers,
    isLoading,
    error,
    refetchContactsDataList: fetchAllContacts,
  };
};
